import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteTemplateMutation } from "modules/ChecklistSettingsDashboard/components/DeleteChecklistTemplateModal/hooks";

type DeleteChecklistTemplatesModalProps = {
  templateID: number | null;
  onClose: () => void;
};

export const DeleteChecklistTemplatesModal = ({ templateID, onClose }: DeleteChecklistTemplatesModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteTemplate, isPending: isDeleteTemplatePending } = useDeleteTemplateMutation();

  const handleDeleteChecklistTemplate = async () => {
    if (templateID === null) return;

    await deleteTemplate({ id: templateID });
    onClose();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={templateID !== null}
      isLoading={isDeleteTemplatePending}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure you want to delete this? You can't undo this action.")}
      handleCancel={onClose}
      handleConfirm={handleDeleteChecklistTemplate}
    />
  );
};
